import { baseURL } from '../../../base-url.js'
import axios from 'axios'

const authorizationHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('jwt')}`
});

export default {
  async fetchAllProducts({ commit }) {
    try {
      const response = await axios.get(`${baseURL}/product/getAllProducts`, {
        headers: authorizationHeaders()
      });
      commit('setProducts', response.data);
      return response.data;
    } catch (error) {
      console.error('Błąd ładowania produkótw:', error);
      throw error.response || error;
    }
  },

  async createProduct(_, payload) {
    try {
      const response = await axios.post(`${baseURL}/product/createProduct`, payload, {
        headers: authorizationHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Błąd tworzenia produktu:', error.response?.data || error.message);
      throw error.response || error;
    }
  },

  async updateProduct(_, payload) {
    try {
      const response = await axios.put(`${baseURL}/product/updateProduct`, payload, {
        headers: authorizationHeaders()
      });
      return response;
    } catch (error) {
      throw error.response || error;
    }
  },

  async deleteProduct(_, transactionId) {
    try {
      const response = await axios.delete(`${baseURL}/product/deleteProduct`, {
        params: { id: transactionId },
        headers: authorizationHeaders()
      });
      return response;
    } catch (error) {
      console.error(`Błąd usuwania produktu:`, error);
      throw error.response;
    }
  },

  async fetchProductStocks(_, productId) {
    try {
      const response = await axios.get(`${baseURL}/product/stock`, {
        params: { productId },
        headers: authorizationHeaders()
      });
      return response.data;
    } catch (error) {
      throw error.response || error;
    }
  },

  async fetchSalonProductStocks(_, salonId) {
    try {
      const response = await axios.get(`${baseURL}/product/stock/by-salon`, {
        params: { salonId },
        headers: authorizationHeaders()
      });
      return response.data;
    } catch (error) {
      throw error.response || error;
    }
  },

  async fetchProductStockSummary(_, { groupBy = 'PRODUCT_SALON', salonId, startDate, endDate } = {}) {
    try {
      const response = await axios.get(`${baseURL}/product/stock/summary`, {
        params: {
          groupBy,
          salonId: salonId || undefined,
          startDate: startDate || undefined,
          endDate: endDate || undefined
        },
        headers: authorizationHeaders()
      });
      return response.data;
    } catch (error) {
      throw error.response || error;
    }
  },

  async setProductStock(_, payload) {
    try {
      const response = await axios.put(`${baseURL}/product/stock`, payload, {
        headers: authorizationHeaders()
      });
      return response.data;
    } catch (error) {
      throw error.response || error;
    }
  },

  async decreaseProductStock(_, payload) {
    try {
      const response = await axios.post(`${baseURL}/product/stock/decrease`, payload, {
        headers: authorizationHeaders()
      });
      return response.data;
    } catch (error) {
      throw error.response || error;
    }
  },

  async fetchProductStockHistory(_, { productId, salonId, page = 0, size = 20 }) {
    try {
      const response = await axios.get(`${baseURL}/product/stock/history`, {
        params: { productId, salonId, page, size },
        headers: authorizationHeaders()
      });
      return response.data;
    } catch (error) {
      throw error.response || error;
    }
  }

}
